export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "agent_synthesis": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Synthèse de l'agent"])},
        "not_sent_to_client": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non envoyée au client"])},
        "internal_notes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Notes internes (optionnel)"])},
        "next_step": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Étape suivante : choisir le type de prise en charge."])},
        "confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Approuver et continuer"])}
      },
      "en": {
        "agent_synthesis": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agent synthesis"])},
        "not_sent_to_client": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Not sent to the customer"])},
        "internal_notes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Internal notes (optional)"])},
        "next_step": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next step: choose the handling type."])},
        "confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Approve and continue"])}
      }
    }
  })
}
